exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.rows-per-page-widget[data-v-fbe14466] {\n  margin-left: 1rem; /* Add space between pagination and rows per page */\n}\n.rows-per-page-widget select[data-v-fbe14466] {\n  width: auto; /* Ensures the select box doesn't stretch */\n  height: 4.7vh;\n  border: 1px solid #dee2e6;\n}\n", ""]);

// exports
